// extracted by mini-css-extract-plugin
export var chip = "_4d-0";
export var filterDropdown = "_4d-5";
export var filterItem = "_4d-6";
export var icon = "_4d-1";
export var removeButton = "_4d-3";
export var removeIcon = "_4d-4";
export var separator = "_4d-2";